import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { RULES } from 'constants/rules.ts';

import Button from 'components/Button';
import Input from 'components/Input';
import Navigator from 'components/Navigator';
import Typography from 'components/Typography';

import { useSimulatorStore } from 'store/useSimulatorStore.ts';

import {
  ClientDataButton,
  ClientDataContainer,
  ClientDataContent,
  ClientDataTitle,
} from './ClientData.styled.ts';

type FormData = {
  nombre: string;
  telefono: string;
};

const ClientData = () => {
  const navigate = useNavigate();

  const { form, saveClientData } = useSimulatorStore();

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<FormData>({
    defaultValues: form || {
      nombre: '',
      telefono: '',
    },
    mode: 'onChange',
  });

  const onSubmit = (data: FormData) => {
    saveClientData(data);
    navigate('/datos-cliente/otp/telefono');
  };

  return (
    <>
      <Navigator title="Cotizar préstamo" />
      <ClientDataContainer>
        <ClientDataContent>
          <ClientDataTitle>
            <Typography type="Title" size="small" style="semibold">
              Datos del cliente
            </Typography>
            <Typography type="Body" size="small" style="light" color="#5C5C5C">
              Ya casi terminamos. Pídele sus datos para verificar su número
              celular y enviarle la cotización.
            </Typography>
          </ClientDataTitle>

          <Controller
            name="nombre"
            control={control}
            rules={RULES.name}
            render={({ field: { onChange, value } }) => {
              return (
                <Input
                  title="Nombre"
                  placeholder="Nombre"
                  maxLength={50}
                  variant="outlined"
                  value={value}
                  onChange={onChange}
                  isValid={!errors?.nombre?.message && value?.length > 0}
                />
              );
            }}
          />

          <Controller
            name="telefono"
            control={control}
            rules={RULES.telephone}
            render={({ field: { onChange, value } }) => {
              return (
                <Input
                  title="Número celular"
                  placeholder="Número celular"
                  variant="outlined"
                  inputMode="numeric"
                  inputType="phone"
                  value={value}
                  onChange={onChange}
                  isValid={!errors?.telefono?.message && value?.length > 0}
                />
              );
            }}
          />
        </ClientDataContent>

        <ClientDataButton>
          <Button
            variant="primary"
            onClick={handleSubmit(onSubmit)}
            disabled={!isValid}
          >
            Verificar celular
          </Button>
        </ClientDataButton>
      </ClientDataContainer>
    </>
  );
};

export default ClientData;
